import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, ordersDetailActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, ordersDetailActions);

export default slice.reducer;
